// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailReturnResult {
    static getAttributeTypeMap() {
        return EmailReturnResult.attributeTypeMap;
    }
}
EmailReturnResult.discriminator = undefined;
EmailReturnResult.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "errorCode",
        "baseName": "errorCode",
        "type": "EmailErrorCode"
    },
    {
        "name": "errorMessage",
        "baseName": "errorMessage",
        "type": "string"
    }
];
//# sourceMappingURL=emailReturnResult.js.map